/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApprovedAccessOrderBy {
    UserDisplayName = 'UserDisplayName',
    UserEmail = 'UserEmail',
    UserMfaPhone = 'UserMfaPhone',
    AccessName = 'AccessName',
    AssignedOn = 'AssignedOn',
    ApplicationName = 'ApplicationName'
}


export function instanceOfApprovedAccessOrderBy(value: any): boolean {
    for (const key in ApprovedAccessOrderBy) {
        if (Object.prototype.hasOwnProperty.call(ApprovedAccessOrderBy, key)) {
            if (ApprovedAccessOrderBy[key as keyof typeof ApprovedAccessOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApprovedAccessOrderByFromJSON(json: any): ApprovedAccessOrderBy {
    return ApprovedAccessOrderByFromJSONTyped(json, false);
}

export function ApprovedAccessOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedAccessOrderBy {
    return json as ApprovedAccessOrderBy;
}

export function ApprovedAccessOrderByToJSON(value?: ApprovedAccessOrderBy | null): any {
    return value as any;
}

export function ApprovedAccessOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): ApprovedAccessOrderBy {
    return value as ApprovedAccessOrderBy;
}

